import { Component, OnInit, Inject } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export interface IDataW9Form {
  w9FullName: string;
  w9AddressStreet: string;
  w9AddressCity: string;
  w9AddressState: string;
  w9AddressZip: string;
  w9AuthorizedDate: Date;
  w9Ssn: string;
  w9SsnLast4: string;
}

@Component({
  selector: 'ebb-portal-dialog-w9form',
  templateUrl: './dialog-w9form.component.html'
})
export class DialogW9formComponent implements OnInit {
  public formW9: FormGroup;
  public currentDate: Date = new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate());
  public agreeToTerms = false;
  public disableSaveButton = true;
  public readOnlySsnLast4 = false;
  public innerHeight;

  constructor(
    public dialogRef: MatDialogRef<DialogW9formComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDataW9Form,
    private fb: FormBuilder   
  ) { }

  ngOnInit() {
    this.innerHeight = window.innerHeight;
    this.initializeForm();
    this.prepopulateForm();
  }

  private initializeForm(): void {
    this.formW9 = this.fb.group({
      w9FullName: ['', Validators.required],
      w9AddressStreet: ['', Validators.required],
      w9AddressCity: ['', Validators.required],
      w9AddressState: ['', Validators.required],
      w9AddressZip: ['', Validators.required],
      w9Ssn: ['', Validators.required],
      confirmReviewedTerms: ['', Validators.requiredTrue]
    });
  }

  private prepopulateForm(): void {
    this.formW9.get('w9FullName').setValue(this.data.w9FullName);
    this.formW9.get('w9AddressStreet').setValue(this.data.w9AddressStreet);
    this.formW9.get('w9AddressCity').setValue(this.data.w9AddressCity);
    this.formW9.get('w9AddressState').setValue(this.data.w9AddressState);
    this.formW9.get('w9AddressZip').setValue(this.data.w9AddressZip);
    if (this.data.w9SsnLast4 && this.data.w9SsnLast4.length > 0) {
      const lastFour = `00000${this.data.w9SsnLast4}`;
      this.formW9.get('w9Ssn').setValue(lastFour);
      this.readOnlySsnLast4 = true;
    }
  }

  public onCheckW9ControlValidators(controlName: string): boolean {
    const retVal = (this.formW9.get(controlName).errors 
                      && (this.formW9.get(controlName).dirty || this.formW9.get(controlName).touched));
    return retVal;
  }

  public onChangeW9Ssn(event): void {
    const ssnValue = this.formW9.get('w9Ssn').value as string;
    if(ssnValue && ssnValue.startsWith('00000') && ssnValue.length < 9){
      this.formW9.get('w9Ssn').setValue('');
      this.readOnlySsnLast4 = false;
    }
  }

  public onChangeEventTerms(event): void {
    this.agreeToTerms = event.checked;
  }

  public onSave(): void {
    this.data.w9FullName = this.formW9.get('w9FullName').value;
    this.data.w9AddressStreet = this.formW9.get('w9AddressStreet').value;
    this.data.w9AddressCity = this.formW9.get('w9AddressCity').value;
    this.data.w9AddressState = this.formW9.get('w9AddressState').value;
    this.data.w9AddressZip = this.formW9.get('w9AddressZip').value;
    this.data.w9Ssn = this.formW9.get('w9Ssn').value;
    this.data.w9AuthorizedDate = this.currentDate;
    this.dialogRef.close(this.data);
  }

  public onClickCancel(): void {
    this.dialogRef.close();
  }

}
